import React from "react";
import { ArrowRight, ArrowLeft } from "../common/IconsV2";

export const MonthNavigator = ({ heading, first, back, next, last, nav }) => {
	const _nav = nav || { nav: { prev: true, next: true } };
	const config = {
		prevCls: _nav.prev
			? "text-black cursor-pointer"
			: "text-gray-400 cursor-default",
		nextCls: _nav.next
			? "text-black cursor-pointer"
			: "text-gray-400 cursor-default",
		prevBgCls: _nav.prev
			? "bg-black cursor-pointer"
			: "bg-gray-400 cursor-default",
		nextBgCls: _nav.next
			? "bg-black cursor-pointer"
			: "bg-gray-400 cursor-default",
		nextDisabled: _nav.next ? false : true,
		prevDisabled: _nav.prev ? false : true,
	};

	return (
		<div className={"mx-2"}>
			<div className="flex flex-row bg-gray-100 rounded-full border-2 border-transparent w-full max-w-sm mx-auto mb-4 mt-2 h-9 px-4">
				<div className="flex justify-between w-2/5  xs:w-1/3">
					<button
						onClick={first}
						type={"button"}
						className={"text-white flex items-center"}
						disabled={config.prevDisabled}
					>
						<span
							className={`block h-3 w-0.5 ${config.prevBgCls} rounded opacity-80`}
						></span>
						<ArrowLeft className={`w-4 ${config.prevCls}`} />
					</button>

					<button
						onClick={back}
						type={"button"}
						className={"text-white block"}
						disabled={config.prevDisabled}
					>
						<ArrowLeft className={`w-4 ${config.prevCls}`} />
					</button>
				</div>

				<span
					className={
						"flex justify-center items-center w-full flex-grow text-center text-sm leading-tight font-bold"
					}
				>
					{heading}
				</span>
				<div className="flex justify-between w-2/5 xs:w-1/3">
					<button
						onClick={next}
						type={"button"}
						className={"text-white block"}
						disabled={config.nextDisabled}
					>
						<ArrowRight className={`w-4 ${config.nextCls}`} />
					</button>

					<button
						onClick={last}
						type={"button"}
						className={"text-white flex items-center"}
						disabled={config.nextDisabled}
					>
						<ArrowRight className={`w-4 ${config.nextCls}`} />
						<span
							className={`block h-3 w-0.5 ${config.nextBgCls} rounded opacity-80`}
						></span>
					</button>
				</div>
			</div>
		</div>
	);
};
